import { CertificateFilters, ExpirationsFilters } from "@/api/williams/certificates";
import { ContractorFilters } from "@/api/williams/contractors";
import { GlobalSearchFilters, IncompleteItemsSearchFilters } from "@/api/williams/search";
import { Project } from "@/api/project";
import { ProjectFilters } from "@/api/williams/project";
import { RenewalAdvisoryRequest } from "@/api/williams/renewals";
import { ScopeOfWork, ScopeOfWorkFilters } from "@/api/williams/scopesOfWork";
import { TestEvent, TestEventFilters } from "@/api/williams/testEvents";
import { TestFilters } from "@/api/williams/tests";
import { WelderFilters, WelderStatusSearch } from "@/api/williams/welders";

export const queryKeys = {
  all: ["williams"],
  project: {
    all: () => [...queryKeys.all, "project"],
    single: (id: string) => [...queryKeys.project.all(), id],
    list: () => [...queryKeys.project.all(), "list"],
    search: (search: string) => [...queryKeys.project.list(), search],
    filter: (filters: Partial<ProjectFilters>) => [...queryKeys.project.list(), filters],
    similar: (project: Project) => [...queryKeys.project.all(), "similar", project],
    associations: (id: string) => [...queryKeys.project.single(id), "associations"],
    metrics: (id: string) => [...queryKeys.project.single(id), "metrics"],
  },
  scopeOfWork: {
    all: () => [...queryKeys.all, "scopeOfWork"],
    single: (id: string) => [...queryKeys.scopeOfWork.all(), id],
    list: () => [...queryKeys.scopeOfWork.all(), "list"],
    search: (search: string) => [...queryKeys.scopeOfWork.list(), search],
    filter: (filters: Partial<ScopeOfWorkFilters>) => [...queryKeys.scopeOfWork.list(), filters],
    advisories: (scope: ScopeOfWork, welder: string) => [...queryKeys.scopeOfWork.single(scope.id), "advisory", welder],
  },
  testEvent: {
    all: () => [...queryKeys.all, "testEvent"],
    single: (id: string) => [...queryKeys.testEvent.all(), id],
    list: () => [...queryKeys.testEvent.all(), "list"],
    search: (search: string) => [...queryKeys.testEvent.list(), search],
    filter: (filters: Partial<TestEventFilters>) => [...queryKeys.testEvent.list(), filters],
    results: (id: string) => [...queryKeys.testEvent.single(id), "results"],
    advisories: (event: TestEvent) => [...queryKeys.testEvent.single(event.id), "advisories", event.welderTests],
  },
  welder: {
    all: () => [...queryKeys.all, "welder"],
    single: (id: string) => [...queryKeys.welder.all(), id],
    list: () => [...queryKeys.welder.all(), "list"],
    search: (search: string) => [...queryKeys.welder.list(), search],
    filter: (filters: Partial<WelderFilters>) => [...queryKeys.welder.list(), filters],
    associations: (id: string) => [...queryKeys.welder.single(id), "associations"],
    picture: (id: string) => [...queryKeys.welder.single(id), "picture"],
    metrics: (id: string) => [...queryKeys.welder.single(id), "metrics"],
    updates: (id: string) => [...queryKeys.welder.single(id), "updates"],
    processStatus: (id: string) => [...queryKeys.welder.single(id), "process-status"],
    statusHistory: (id: string) => [...queryKeys.welder.single(id), "status-history"],
    status: (id: string, filters?: WelderStatusSearch) => [...queryKeys.welder.single(id), "status", filters],
  },
  certificates: {
    all: () => [...queryKeys.all, "certificate"],
    single: (id: string) => [...queryKeys.certificates.all(), id],
    list: () => [...queryKeys.certificates.all(), "list"],
    search: (search: string) => [...queryKeys.certificates.list(), search],
    filter: (filters: Partial<CertificateFilters>) => [...queryKeys.certificates.list(), filters],
  },
  expirations: {
    all: () => [...queryKeys.all, "expirations"],
    single: (id: string, process: string, type: string) => [...queryKeys.expirations.all(), id, process, type],
    list: () => [...queryKeys.expirations.all(), "list"],
    search: (search: string) => [...queryKeys.expirations.list(), search],
    filter: (filters: Partial<ExpirationsFilters>) => [...queryKeys.expirations.list(), filters],
  },
  contractor: {
    all: () => [...queryKeys.all, "contractor"],
    single: (id: string) => [...queryKeys.contractor.all(), id],
    list: () => [...queryKeys.contractor.all(), "list"],
    search: (search: string) => [...queryKeys.contractor.list(), search],
    filter: (filters: Partial<ContractorFilters>) => [...queryKeys.contractor.list(), filters],
    associations: (id: string) => [...queryKeys.contractor.single(id), "associations"],
    metrics: (id: string) => [...queryKeys.contractor.single(id), "metrics"],
  },
  standardTests: {
    all: () => [...queryKeys.all, "standardTest"],
    single: (id: string) => [...queryKeys.standardTests.all(), id],
    list: () => [...queryKeys.standardTests.all(), "list"],
    search: (search: string) => [...queryKeys.standardTests.list(), search],
    filter: (filters: Partial<TestFilters>) => [...queryKeys.standardTests.list(), filters],
  },
  user: {
    all: () => [...queryKeys.all, "user"],
    single: (id: string) => [...queryKeys.user.all(), id],
    list: () => [...queryKeys.user.all(), "list"],
    search: (search: string) => [...queryKeys.user.list(), search],
    roles: () => [...queryKeys.user.all(), "roles"],
    permissions: () => [...queryKeys.user.all(), "permissions"],
    weldingSpecialists: () => [...queryKeys.user.all(), "specialists"],
  },
  search: {
    all: () => [...queryKeys.all, "search"],
    global: (filters: Partial<GlobalSearchFilters>) => [...queryKeys.search.all(), filters],
    incomplete: (filters: Partial<IncompleteItemsSearchFilters>) => [...queryKeys.search.all(), "incomplete", filters],
  },
  renewal: {
    advisories: (renewal: RenewalAdvisoryRequest) => ["renewal", "advisories", renewal],
  },
  dashboard: {
    stats: () => [...queryKeys.all, "dashboard", "stats"],
  },
};
